/* PIKOVA — the small amount of behaviour the brand needs.
   Ported from the prototype's site.js, with three things deliberately dropped:

   - the page-fade on navigation, which intercepted every click and would fight
     Dawn's cart drawer, predictive search and variant links;
   - the burger and drawer, which Dawn already owns and does accessibly;
   - the fbq/gtag hooks, since the Meta pixel arrives through the sales channel
     and a second copy would double-count every event.

   What remains: the loading mark, the header settling, and the reveal. */

(function () {
  'use strict';

  /* ── the mark holds the screen until the page has painted ─────────────── */
  var load = document.getElementById('pk-load');

  function lift() {
    if (!load || load.classList.contains('pk-gone')) return;
    load.classList.add('pk-gone');
    setTimeout(function () {
      load.style.display = 'none';
    }, 650);
  }

  if (document.readyState === 'complete') setTimeout(lift, 420);
  else addEventListener('load', function () { setTimeout(lift, 420); });

  // never let a slow film keep the mark up for ever
  setTimeout(lift, 3000);

  // returning with the back button must not leave the mark stranded
  addEventListener('pageshow', function (e) {
    if (e.persisted) lift();
  });

  /* ── the header floats over a full-bleed opening ──────────────────────── */

  // Two sections open a page full-bleed: the original pagehead, and the hero
  // once it was rebuilt to the same pattern. Either one earns the floating,
  // transparent header.
  //
  // It has to be the page's *first* section. Asking the document whether a
  // pagehead exists anywhere says yes to one sitting halfway down, and the
  // header would then float over whatever the page actually opens with.
  //
  // The body class keeps its old name on purpose. These files are pasted into
  // the client store one at a time, and renaming it would break the header on
  // any store that had taken the script but not yet the stylesheet.
  var openers = ['pk-pagehead-section', 'pk-hero-section'];
  var first = document.querySelector('#MainContent .shopify-section');
  if (first && openers.some(function (name) { return first.classList.contains(name); })) {
    document.body.classList.add('pk-has-pagehead');
  }

  if (document.querySelector('.pk-gate-section')) {
    document.body.classList.add('pk-has-gate');
  }

  // The header group is several sibling sections rather than one wrapper, so
  // its height is the sum of them. The content below is pulled up by exactly
  // that much; guessing it would leave a gap on one screen size or clip the
  // announcement bar on another.
  function measureHead() {
    var parts = document.querySelectorAll('.shopify-section-group-header-group');
    if (!parts.length) return;
    var total = 0;
    parts.forEach(function (part) {
      total += part.offsetHeight;
    });
    document.documentElement.style.setProperty('--pk-head-h', total + 'px');
  }

  // Measuring the moment a resize fires reads the old layout: the header has
  // not rewrapped yet, so the figure is short and a strip of background shows
  // above the film. Waiting for the next frame reads the header as it now is.
  function remeasure() {
    requestAnimationFrame(measureHead);
  }

  // Measured on every page, not only the ones opening with a full-bleed
  // picture. Anything anchored — the process page's parts, linked to from the
  // homepage steps — needs to know where the header ends so the heading it
  // scrolls to does not arrive underneath it.
  measureHead();
  addEventListener('load', remeasure);
  addEventListener('resize', remeasure, { passive: true });
  addEventListener('orientationchange', remeasure);
  document.addEventListener('shopify:section:load', remeasure);

  // web fonts land after first paint and change the header's height with them
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(remeasure);
  }

  /* ── the header earns its ground once you have scrolled ───────────────── */
  // Dawn's class is section-header; shopify-section-header does not exist and
  // never has, so this quietly did nothing until it was measured.
  var head = document.querySelector('.section-header');
  if (head) {
    var settle = function () {
      head.classList.toggle('pk-settled', scrollY > 20);
    };
    addEventListener('scroll', settle, { passive: true });
    settle();
  }

  /* ── each block rises once, as it arrives ─────────────────────────────── */
  var blocks = document.querySelectorAll('.pk-rise');
  if (!blocks.length) return;

  // only now, with the script running, is it safe to hide anything
  document.documentElement.classList.add('pk-js');

  var showAll = function () {
    blocks.forEach(function (b) { b.classList.add('pk-in'); });
  };

  // whatever happens, nothing stays hidden for more than a moment
  setTimeout(showAll, 2200);

  if (!('IntersectionObserver' in window)) {
    showAll();
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('pk-in');
        io.unobserve(en.target);
      });
    },
    { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }
  );

  blocks.forEach(function (b, i) {
    b.style.transitionDelay = (i % 3) * 90 + 'ms';
    io.observe(b);
  });

  // a jump straight to a section must not land on an invisible block
  var sweep = function () {
    blocks.forEach(function (b) {
      var r = b.getBoundingClientRect();
      if (r.top < innerHeight && r.bottom > 0) b.classList.add('pk-in');
    });
  };

  addEventListener('hashchange', function () { setTimeout(sweep, 60); });
  addEventListener('load', sweep);
  sweep();
  setTimeout(sweep, 400);

  // the theme editor drops new sections in after load; they must rise too
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.pk-rise:not(.pk-in)').forEach(function (b) {
      io.observe(b);
    });
  });
})();
